// Breaking a codestring down into its RDM code items (GET codestring/{formatNumber}), as getCodeStringSplit
// does in design-schedule-api: each item is the substring at its 1-based position and length.

// The item is inside the codestring, so it can be read and changed
export const fits = (codeString, item) =>
  item.length > 0 && item.position > 0 && item.position - 1 + item.length <= codeString.length;

// Value of each item; "" when the codestring ends before it
export const splitCodeString = (codeString, items) =>
  items.map((item) => (fits(codeString, item) ? codeString.substr(item.position - 1, item.length) : ""));

// Writes each changed value ({ itemIndex: value }) over its positions; the rest stays as it was. A value of the
// wrong length (still being typed) is fitted so the other items keep their place
export const applyChanges = (codeString, items, changes) =>
  Object.entries(changes).reduce((result, [index, value]) => {
    const item = items[index];
    const start = item.position - 1;
    return result.slice(0, start) + value.padEnd(item.length).slice(0, item.length) + result.slice(start + item.length);
  }, codeString);

// RDM may store an option without its trailing spaces
export const optionValue = (item, option) => option.value.padEnd(item.length);

export const optionFor = (item, value) => item.options.find((option) => optionValue(item, option) === value);

// Blocking problem of a typed value, or ""
export const valueError = (item, value) =>
  value.length !== item.length ? `Must be ${item.length} character${item.length === 1 ? "" : "s"}` : "";

// Pieces of the codestring for the preview: the item that owns each run of characters (null = no item)
export const segments = (codeString, items) => {
  const owner = new Array(codeString.length).fill(null);
  items.forEach((item, index) => {
    if (!fits(codeString, item)) return;
    for (let i = item.position - 1; i < item.position - 1 + item.length; i++) {
      if (owner[i] === null) owner[i] = index;
    }
  });
  const result = [];
  owner.forEach((index, i) => {
    const last = result[result.length - 1];
    if (last && last.index === index) last.text += codeString[i];
    else result.push({ index, text: codeString[i] });
  });
  return result;
};
